/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  Container,
  Dropdown,
  Modal,
} from "@themesberg/react-bootstrap";

import { useState } from "react";
import { useCallback } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { deleteApi, fetchApi, postApi } from "../../../redux/api";
import { getFileUrl } from "../../../utils/fileUrl";
import CustomTable from "../../../components/CustomTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faEdit,
  faEye,
  faListUl,
  faPlus,
  faTrash,
  faCheckDouble,
} from "@fortawesome/free-solid-svg-icons";
import { Routes } from "../../../routes";
import { formatNumber } from "../../../redux/utils";
import { useSelector } from "react-redux";
import { SearchContext } from "../../HomePage";
import { Col, Form, Row } from "react-bootstrap";
import SearchInput from "../../../components/SearchInput";
import { toast } from "react-hot-toast";

export const OAGOFFICE = 'Office of the Accountant-General'
function PVReviewIndex({ match, type = null, mdaType, mode }) {
  const history = useNavigate();
  const location = useLocation();
  const isReview = mode === "review" || location.pathname.includes("review-index");
  const isAdCheck = location.pathname.includes("checkad-index");
  const isCheck = mode === "check" || location.pathname.includes("check-index");
  const isApprove = mode === "approve" || location.pathname.includes("approve-index");
  const user = useSelector((state) => state.auth.user);
  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif"];
  const [filterText, setFilterText] = useState("");
  const batch_no = useParams().batch_no;
  const [pvList, setPvList] = useState([]);
  const [modal, setModal] = useState(false);
  const [filter, setFilter] = useState(type || "All");
  const [attachmentModalIsOpen, setAttachmentModalIsOpen] = useState(false);
  const [selectedPV, setSelectedPvNo] = useState("");
  const [pvImageInfo, setPvImageInfo] = useState([]);
  const [item, setItem] = useState({});
  const [_delete, setDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [selectedPvs, setSelectedPvs] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const { searchTerm, setSearchTerm } = useContext(SearchContext);

  const isMdaPv = location.pathname.includes("mda-pv")

  const toggleSelectPv = (pvCode) => {
    setSelectedPvs(prev =>
      prev.includes(pvCode)
        ? prev.filter(c => c !== pvCode)
        : [...prev, pvCode]
    );
  };

  const toggleSelectAll = () => {
    if (selectedPvs.length === pvList.length) {
      setSelectedPvs([]);
    } else {
      setSelectedPvs(pvList.map(p => p.pv_code));
    }
  };

  const approveSelected = () => {
    if (!selectedPvs.length) {
      toast.error("Please select PVs to approve");
      return;
    }
    setLoading(true);
    const newStatus = isCheck
      ? (isMdaPv ? "MDA Checked" : "Checked")
      : isReview
        ? (isMdaPv ? "MDA Reviewed" : "Reviewed")
        : isApprove
        ? (isMdaPv ? "SA_approved" : "Approved")
        : "";

    const promises = selectedPvs.map(pvCode =>
      postApi("update-pv", {
        pv_code: pvCode,
        status: newStatus,
        userId: user?.username || "",
        remarks: `Bulk ${isCheck ? 'checked' : isReview ? 'reviewed' : 'approved'} from ${isCheck ? 'Check' : isReview ? 'Review' : 'Approve'} PV page`,
      })
    );

    Promise.all(promises)
      .then(results => {
        const successCount = results.filter(r => r.success).length;
        if (successCount > 0) {
          toast.success(`${successCount} of ${selectedPvs.length} PV(s) updated to "${newStatus}"`);
        }
        if (successCount < selectedPvs.length) {
          toast.error(`${selectedPvs.length - successCount} PV(s) failed`);
        }
        setSelectedPvs([]);
        getPvCollection();
      })
      .catch(err => {
        toast.error("Error updating PVs. Please try again.");
      })
      .finally(() => setLoading(false));
  };
  const toggleDelete = (item) => {
    setItem(item);
    setDelete(!_delete);
  };
  //   const [approvalList, setApprovalList] = useState([]);

  const attachmentModalToggle = () => {
    setAttachmentModalIsOpen((p) => !p);
  };

  const viewAttachment = (imageid, pv) => {
    setSelectedPvNo(pv);
    fetchApi(`fetch-pv-images?pv_no=${imageid}`).then((resp) => {
      attachmentModalToggle();
      if (resp.results && resp.results.length) {
        setPvImageInfo(resp.results);
      } else {
        setPvImageInfo({});
      }
    });
  };

  const getPvCollection = useCallback(() => {
    setLoading(true);
    if(user && user.mda_name === OAGOFFICE) {
      postApi(`get_pv_collection`, {
        form: {
          query_type: "pv_by_mda",
          pv_status: isCheck ? "Pending" : /*isAdCheck ? "Checked"  :*/ isReview ? "Checked" : isApprove ? "Reviewed" : "",
          mda_name: user?.mda_name, mda_code: user?.mda_code || "",
          mda_type: mdaType || "",
        },
      })
        .then((data) => {
          // console.log('data', data)
          if (data.result) {
            const arr = [];
            data.result.forEach((item) => {
              arr.push({ ...item, isOpen: false });
            });
            setPvList(data.result);
          }
        })
  
        .catch((err) => {
          // alert(err);
          // setLoadSpinner(false);
        })
      .finally(() => setLoading(false));
    } else {
      postApi(`get_pv_collection`, {
        form: {
          query_type: isMdaPv ? "single_pv_by_mda" : "pv_by_mda",
          pv_status: isCheck ? isMdaPv ? "MDA Pending" : "Pending" : isReview ? isMdaPv ? "MDA Checked" : "Checked" : isApprove ? isMdaPv ? "MDA Reviewed" : "Reviewed" : "",
          mda_name: user?.mda_name, mda_code: user?.mda_code || "",
          mda_type: mdaType || "",
        },
      })
        .then((data) => {
          // console.log('data', data)
          if (data.result) {
            const arr = [];
            data.result.forEach((item) => {
              arr.push({ ...item, isOpen: false });
            });
            setPvList(data.result);
          }
        })
  
        .catch((err) => {
          // alert(err);
          // setLoadSpinner(false);
        })
        .finally(() => setLoading(false));
      }
  }, [user, isCheck, isReview, isApprove, user.mda_name]);

  useEffect(() => {
    getPvCollection();
  }, [getPvCollection]);

  // const handleDelete = () => {
  //   _setLoading(true)
  //   deleteApi(`delete-pv-collection`, item)
  //     .then(() => {
  //       alert('Deleted Successfully')
  //       _setLoading(false)
  //       getPvCollection()
  //       toggleDelete({})
  //     })
  //     .catch((err) => {
  //       alert(`error occured ${JSON.stringify(err)}`)
  //       _setLoading(false)
  //     })
  // }

  const handleFilter = () => {
    const filteredList = pvList.filter((item) => {
      const dateFromCondition = dateFrom ? new Date(item.date) >= new Date(dateFrom) : true;
      const dateToCondition = dateTo ? new Date(item.date) <= new Date(dateTo) : true;
      return dateFromCondition && dateToCondition;
    });
    return filteredList;
  };

  useEffect(() => {
    handleFilter();
  }, [dateFrom, dateTo]);

  const filteredList = handleFilter();

  let list = [];
  filteredList.forEach((item) => {
    if (filterText && (
      !item.approval_no ||
      (item.approval_no.indexOf(filterText) === -1 &&
       item.approval_no.toString().indexOf(filterText.toLowerCase()) === -1)
    ))
      return;
    else list.push(item);
  });

  const selfSustainingFields = [
    {
      title: "",
      headerComponent: () => (
        <Form.Check
          type="checkbox"
          checked={selectedPvs.length === pvList.length && pvList.length > 0}
          onChange={toggleSelectAll}
        />
      ),
      component: (item) => (
        <Form.Check
          type="checkbox"
          checked={selectedPvs.includes(item.pv_code)}
          onChange={() => toggleSelectPv(item.pv_code)}
        />
      ),
      style: { textAlign: "center", width: 40 },
    },
    {
      title: "Action",
      custom: true,
      component: (item, index) => (
          <Button
            size="sm"
            onClick={() => {
              const navApprovalNo = item.approval_no ? `&approval_no=${encodeURIComponent(item.approval_no)}` : '';
              if (isReview) {
                history(
                  `${Routes.pv.viewPvReview}?approval_type=${encodeURIComponent(item.approval_type)}${navApprovalNo}&pv_code=${encodeURIComponent(item.pv_code)}&mda_type=${encodeURIComponent(mdaType || "")}`
                );
              } if (isAdCheck) {
                history(
                  `${Routes.pv.viewPvADCheck}?approval_type=${encodeURIComponent(item.approval_type)}${navApprovalNo}&pv_code=${encodeURIComponent(item.pv_code)}&mda_type=${encodeURIComponent(mdaType || "")}`
                );} if (isCheck) {
                history(
                  `${Routes.pv.viewPvCheck}?approval_type=${encodeURIComponent(item.approval_type)}${navApprovalNo}&pv_code=${encodeURIComponent(item.pv_code)}&mda_type=${encodeURIComponent(mdaType || "")}`
                );
              } else if (isApprove) {
                history(
                  `${Routes.pv.viewPvApprove}?approval_type=${encodeURIComponent(item.approval_type)}${navApprovalNo}&pv_code=${encodeURIComponent(item.pv_code)}&mda_type=${encodeURIComponent(mdaType || "")}`
                );
              }
            }}
        >
          <FontAwesomeIcon icon={faEye} className="me-1" />
          View
        </Button>
      ),
    },

    {
      title: "PV Code",
      value: "pv_code",
    },
    {
      title: "Beneficiary",
      value: "contractor_name",
    },
    {
      title: "Narration",
      value: "narration",
    },
    {
      title: "Status",
      value: "status",
    },
    {
      title: "Amount (N)",
      custom: true,
      component: (item) => (
        <div className="text-end">{formatNumber(item.amount)}</div>
      ),
      //   value: 'amount',
    },
  ]

  const fields = [
    {
      title: "Action",
      custom: true,
      component: (item, index) => (
          <Button
            onClick={() => {
              const navApprovalNo = item.approval_no ? `&approval_no=${encodeURIComponent(item.approval_no)}` : '';
              if (isReview) {
                history(
                  `${Routes.pv.viewPvReview}?approval_type=${encodeURIComponent(item.approval_type)}${navApprovalNo}&pv_code=${encodeURIComponent(item.pv_code)}&mda_type=${encodeURIComponent(mdaType || "")}`
                );
              } if (isAdCheck) {
                history(
                  `${Routes.pv.viewPvADCheck}?approval_type=${encodeURIComponent(item.approval_type)}${navApprovalNo}&pv_code=${encodeURIComponent(item.pv_code)}&mda_type=${encodeURIComponent(mdaType || "")}`
                );} if (isCheck) {
                history(
                  `${Routes.pv.viewPvCheck}?approval_type=${encodeURIComponent(item.approval_type)}${navApprovalNo}&pv_code=${encodeURIComponent(item.pv_code)}&mda_type=${encodeURIComponent(mdaType || "")}`
                );
              } else if (isApprove) {
                history(
                  `${Routes.pv.viewPvApprove}?approval_type=${encodeURIComponent(item.approval_type)}${navApprovalNo}&pv_code=${encodeURIComponent(item.pv_code)}&mda_type=${encodeURIComponent(mdaType || "")}`
                );
              }
            }}
        >
          View
        </Button>
      ),
    },

    {
      title: "Approval No.",
      value: "approval_no",
    },

    {
      title: "Number of PVs",
      custom: true,
      value: "no_of_pvs",
      component: (item) => (
        <div className="text-end">{(item.no_of_pvs)}</div>
      ),
    },
    {
      title: "Status",
      value: "status",
    },
    {
      title: "Amount (N)",
      custom: true,
      component: (item) => (
        <div className="text-end">{formatNumber(item.amount)}</div>
      ),
      //   value: 'amount',
    },
  ];

  const finalList = [];
  list.forEach((item) => {
    if (!item.approval_no || item.approval_no.indexOf(searchTerm.toLowerCase()) === -1)
      return;
    finalList.push(item);
  });

  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, [setSearchTerm]);

  const getRowStyle = (row) => {
    if (row.status.includes("Return")) {
      return { backgroundColor: "orange" };
    } else {
      return {}
    }
  }

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        {/* <Button
            onClick={() => history(Routes.pv.newPv)}
            className="me-2"
          > <FontAwesomeIcon icon={faPlus} className='me-2' />
            Add PV
          </Button> */}
        {/* {JSON.stringify(pvList)} */}
        <div className="d-block mb-4 mb-md-0">
          <h4>
            {/* <FontAwesomeIcon icon={faListUl} className="me-2" />  */}
            {/* Generate Payment Voucher */}
            {isReview
              ? "Review PVs"
              : isCheck
                ? "Check PVs"
                : isApprove
                  ? "Approve PVs"
                  : "Pending Releases"}
          </h4>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup>
            {selectedPvs.length > 0 && (
              <span className="d-flex align-items-center me-2 text-muted small">
                {selectedPvs.length} selected
              </span>
            )}
            <Button
              variant="success"
              size="sm"
              disabled={!selectedPvs.length || loading}
              onClick={() => setShowConfirmModal(true)}
            >
              <FontAwesomeIcon icon={faCheckDouble} className="me-1" />
              {loading ? 'Processing...' : `Approve Selected${selectedPvs.length > 0 ? ` (${selectedPvs.length})` : ''}`}
            </Button>
            <Button variant="outline-primary" size="sm">
              Share
            </Button>
            <Button variant="outline-primary" size="sm">
              Export
            </Button>
          </ButtonGroup>
        </div>
      </div>

      {/* {JSON.stringify({pvList, user})} */}
      <Row>
        <Col md={6} style={{
          marginTop: 28
        }}>
          <SearchInput
            placeholder="Search For Review Releases"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </Col>
        <Col md={6}>
          <Row style={{
            marginBottom: 10
          }}>
            <Col md={6}>
              <Form.Group id="date_from">
                <Form.Label>Date From</Form.Label>
                <Form.Control
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group id="date_to">
                <Form.Label>Date to</Form.Label>
                <Form.Control
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>


      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body
          className="p-0"
          style={{ height: "80vh", overflow: "scroll" }}
        >
          {loading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <CustomTable
              fields={ isMdaPv ? selfSustainingFields : fields}
              data={ isMdaPv ? pvList : finalList}
              // currentPage={currentPage}
              // handlePageChange={handlePageChange}
              getRowStyle={(data) => getRowStyle(data)}
            />
          )}
        </Card.Body>

        <Modal show={attachmentModalIsOpen} onHide={attachmentModalToggle}>
          <Modal.Header onHide={attachmentModalToggle}>
            PV No.: {selectedPV}
          </Modal.Header>
          <Modal.Body className="text-center">
            <Container>
              <div className="image-container">
                {pvImageInfo.length ? (
                  pvImageInfo.map((item, index) =>
                    imageExtensions.some((extension) =>
                      item.image_url.toLowerCase().endsWith(extension)
                    ) ? (
                      <Card.Img
                        top
                        src={getFileUrl(item.image_url)}
                        alt={"pv"}
                      />
                    ) : (
                      <Card.Body>
                        <Card.Link
                          href={getFileUrl(item.image_url)}
                          target="_blank"
                        >
                          View PDF
                        </Card.Link>
                      </Card.Body>
                    )
                  )
                ) : (
                  <h4>No attachment found.</h4>
                )}
              </div>
            </Container>
            {/* <h6>MDA: {approvalImageInfo.mda_name}</h6> */}
          </Modal.Body>
        </Modal>

        {/* Confirmation Modal for Bulk Approve */}
        <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>
              <FontAwesomeIcon icon={faCheckDouble} className="me-2 text-success" />
              Confirm Approval
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-2">
              Are you sure you want to update the status of <strong>{selectedPvs.length} PV(s)</strong>?
            </p>
            <div className="text-muted small mb-3">
              New status: <strong className="text-success">
                {isCheck
                  ? (isMdaPv ? "MDA Checked" : "Checked")
                  : isReview
                    ? (isMdaPv ? "MDA Reviewed" : "Reviewed")
                    : isApprove
                      ? (isMdaPv ? "SA_approved" : "Approved")
                      : ""}
              </strong>
            </div>
            {selectedPvs.length > 0 && (
              <>
                <p className="fw-bold mb-2">Selected PVs:</p>
                <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                  {pvList
                    .filter(p => selectedPvs.includes(p.pv_code))
                    .map(p => (
                      <div key={p.pv_code} className="d-flex justify-content-between small py-1 border-bottom">
                        <span>{p.pv_code}</span>
                        <span className="text-muted">{p.contractor_name}</span>
                        <span className="text-end">₦{formatNumber(p.amount)}</span>
                      </div>
                    ))}
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={() => setShowConfirmModal(false)}>
              Cancel
            </Button>
            <Button
              variant="success"
              onClick={() => {
                setShowConfirmModal(false);
                approveSelected();
              }}
            >
              <FontAwesomeIcon icon={faCheckDouble} className="me-1" />
              Confirm & Approve
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={_delete} onHide={toggleDelete}>
          <Modal.Header onHide={toggleDelete}>Delete</Modal.Header>
          <Modal.Body className="text-center">
            <h5>Are you sure you want to delete {item.pv_code} </h5>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <Button outline className="m-1 p-1 px-3" onClick={toggleDelete}>
                Cancel
              </Button>
              <Button
                color="danger"
                className="m-1 p-1 px-3"
                // onClick={handleDelete}
                loading={loading}
              >
                Delete
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </Card>
    </>
  );
}

export default PVReviewIndex;
